import {isAuthenticationEnabled} from 'helpers/security'

const isSecure = isAuthenticationEnabled()

const defaultAuthState = {
  isAuthenticated: false,
  user: {
    isAdmin: !isSecure,
    name: isSecure ? '' : 'Dev User',
    email: isSecure ? '' : 'dev-user@mdsol.com',
    initials: isSecure ? '' : 'DU',
    isPowerUser: !isSecure,
  },
}

export type AuthStateType = typeof defaultAuthState

export type AuthUserStateType = typeof defaultAuthState.user

export default defaultAuthState
